import { useEffect, useState } from "react";
import { GiftReceivedPopup } from "./GiftReceivedPopup";
import { useGiftPopup } from "@/hooks/useGiftPopup";
import { acquirePopup, releasePopup, cancelPopup, POPUP_PRIORITIES } from "@/lib/popupQueue";

const POPUP_ID = "gift-received";

export function GiftPopupProvider() {
  const { isOpen, popupData, dismissPopup, acceptFromPopup } = useGiftPopup();
  const [canShow, setCanShow] = useState(false);

  useEffect(() => {
    if (isOpen) {
      let cancelled = false;
      acquirePopup(POPUP_ID, POPUP_PRIORITIES.gift).then(() => {
        if (!cancelled) setCanShow(true);
        else releasePopup(POPUP_ID);
      });
      return () => {
        cancelled = true;
        cancelPopup(POPUP_ID);
      };
    } else {
      setCanShow(false);
      releasePopup(POPUP_ID);
    }
  }, [isOpen]);

  const handleDismiss = () => {
    setCanShow(false);
    releasePopup(POPUP_ID);
    dismissPopup();
  };

  const handleAccept = async () => {
    const result = await acceptFromPopup();
    setCanShow(false);
    releasePopup(POPUP_ID);
    return result;
  };

  return (
    <GiftReceivedPopup
      isOpen={canShow}
      data={popupData}
      onDismiss={handleDismiss}
      onAccept={handleAccept}
    />
  );
}
